import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
const isTriggerCharacter = triggerCharacter => triggerCharacter != null && triggerCharacter.length > 0;
const getAutoCompletionInput = _ref => {
  let {
    context,
    model,
    position
  } = _ref;
  const {
    triggerCharacter
  } = context;
  let adjustedPositionForTriggerCharacter = position;
  if (isTriggerCharacter(triggerCharacter)) {
    adjustedPositionForTriggerCharacter = position.with(position.lineNumber, position.column - triggerCharacter.length);
  }
  const wordAtOriginalPosition = model.getWordUntilPosition(adjustedPositionForTriggerCharacter);
  let adjustedWordAtPositionForTriggerCharacter = wordAtOriginalPosition;
  if (isTriggerCharacter(triggerCharacter)) {
    adjustedWordAtPositionForTriggerCharacter = _objectSpread(_objectSpread({}, wordAtOriginalPosition), {}, {
      endColumn: adjustedPositionForTriggerCharacter.column + triggerCharacter.length,
      word: "".concat(wordAtOriginalPosition.word).concat(triggerCharacter)
    });
  }
  const rangeToReplace = {
    endColumn: adjustedWordAtPositionForTriggerCharacter.endColumn,
    endLineNumber: position.lineNumber,
    startColumn: adjustedWordAtPositionForTriggerCharacter.startColumn,
    startLineNumber: position.lineNumber
  };
  return {
    rangeToReplace,
    wordAtPosition: adjustedWordAtPositionForTriggerCharacter
  };
};
export default getAutoCompletionInput;